/**
 * Referral Utilities
 *
 * Utilities for handling referral codes during Clerk registration flow.
 * Handles URL parameter detection, sanitization, and localStorage management.
 */

import { sanitizeRefCode } from '../features/referrals/utils/sanitizeRefCode';

const REFERRAL_CODE_KEY = 'pending_referral_code';

/**
 * Get referral code from URL query parameters
 * @returns Sanitized referral code or null if not present
 */
export const getReferralCodeFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('ref');

  if (!refCode) return null;

  return sanitizeRefCode(refCode);
};

/**
 * Store referral code in localStorage for use after registration
 * @param code - Referral code to store
 */
export const storeReferralCodeForUser = (code: string): void => {
  localStorage.setItem(REFERRAL_CODE_KEY, code);
};

/**
 * Retrieve stored referral code from localStorage
 * @returns Stored referral code or null if not found
 */
export const getStoredReferralCode = (): string | null => {
  return localStorage.getItem(REFERRAL_CODE_KEY);
};

/**
 * Clear stored referral code from localStorage
 */
export const clearStoredReferralCode = (): void => {
  localStorage.removeItem(REFERRAL_CODE_KEY);
};
